<p-drawer
  [(visible)]="visible"
  position="right"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-profile-sidebar w-full sm:w-25rem"
>
  <div class="flex flex-column mx-auto md:mx-0 h-full">
    <span class="mb-2 font-semibold">Dobrodošli</span>

    <span class="text-color-secondary font-medium mb-5">{{ username }}</span>

    <ul class="list-none m-0 p-0 h-full">
      <li>
        <a
          class="logout-button cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150"
          (click)="logout()"
        >
          <span>
            <i class="pi pi-power-off text-xl text-primary"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold">Odjava</span>
          </div>
        </a>
      </li>
    </ul>

    <div class="footer">
      <div class="powered-by">
        <img
          src="/assets/images/digital-lab.png"
          alt=""
          style="max-width: 100px"
        />
      </div>
      <small>
        Verzija: <strong style="font-weight: 600">{{ version }}</strong>
      </small>
    </div>
  </div>
</p-drawer>
